import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import _ from 'lodash';

import * as mmHelper from '../../../network/mmHelper';
import { getDispatchHistoryList, updateDispatchHistory } from "../../../actions/mmActions";
import { getOpenLoadBatchIdDialog, handleLoadBatchIdDialog, showAlertSnackbar } from "../../../reducers/uiSlice";
import { getUserPreference } from "../../../utilities/common";
import UniDialog from "../../Common/UniDialog";
import SelectDispatchHistory from "../../MapManagement/SelectDispatchHistory";


export function LoadDispatchHistoryModal(props){
    const {t} = useTranslation('dialog');
    const dispatch = useDispatch();
    const openLoadBatchIdDialog = useSelector(getOpenLoadBatchIdDialog);
    const userPref = getUserPreference();

    const {isLoading, dispatchHistoryList} = props
    const [loadBatchIds, setLoadBatchIds] = useState("");
    const [deleteDispatchId, setDeleteDispatchId] = useState('');
    const [historyList, setHistoryList] = useState([]);

    useEffect(() => {
        if(dispatchHistoryList) {
            setDeleteDispatchId('');
            if(dispatchHistoryList.length > 0) {
                let historyListCurr = [];
                dispatchHistoryList.map((dispatch) => {
                    if(!dispatch.is_removed) {
                        historyListCurr.push(dispatch)
                    }
                })
                setHistoryList(historyListCurr);
            }
        }
    }, [dispatchHistoryList])

    return (
        <UniDialog
            title={t('load_dispatch_history_title')}
            maxWidth='sm'
            fullWidth
            open={openLoadBatchIdDialog}
            onClose={()=>dispatch(handleLoadBatchIdDialog(false))}
            onFinish={handleSubmitLoadBatchId}
            openFunction={fetchDispatchHistoryList}
            onDelete={handleSubmitDeleteDispatchId}
            enableDelete={deleteDispatchId}
        >
            <SelectDispatchHistory 
                data={historyList}
                isLoading={isLoading}
                handleSelectedDispatchGroup={(ids)=>setLoadBatchIds(ids)}
                handleSelectDispatchId={handleSelectDispatchId}
            />
        </UniDialog>
    )

    function handleSubmitDeleteDispatchId() {
        dispatch(updateDispatchHistory(deleteDispatchId, userPref.userCity))
        .then(() => {
            dispatch(showAlertSnackbar({type: "success", message: 'Deleted successfully!' }));
            fetchDispatchHistoryList();
            setDeleteDispatchId('');
        })
        .catch(() => {
            dispatch(showAlertSnackbar({type: "error", message: 'Failed to delete!' }));
            setDeleteDispatchId('');
        })
    }

    function handleSelectDispatchId(idArr) {
        setDeleteDispatchId(idArr[0]);
    }

    function handleSubmitLoadBatchId(){
        if(loadBatchIds.length <= 0){
            return 
        }
        let ids = _.split(loadBatchIds, ",").map(item=>item.trim())
        //Fetch new staff list, reset orders
        mmHelper.batchChange(dispatch, userPref.userCity, ids, userPref.hideAssociatedOrders, userPref.hideSubReferrer)
    }

    function fetchDispatchHistoryList(){
        if(!isLoading)
            dispatch(getDispatchHistoryList(userPref.userCity))
    }
}